/** One single-choice question of the onboarding form, as a row of radio pills. */
type Props = {
  label: string;
  name: string;
  options: readonly string[];
  value: string;
  onChange: (next: string) => void;
};

export function OnboardingPillGroup({ label, name, options, value, onChange }: Props) {
  return (
    <fieldset className="onboarding-field onboarding-pills-field">
      <legend>{label}</legend>
      <div className="onboarding-pills" role="radiogroup" aria-label={label}>
        {options.map((opt) => {
          const active = opt === value;
          return (
            <button
              key={opt}
              type="button"
              role="radio"
              aria-checked={active}
              className={
                active ? 'onboarding-pill onboarding-pill-active' : 'onboarding-pill'
              }
              onClick={() => onChange(opt)}
              data-name={name}
            >
              {opt}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
